export default {
  EDocumentStatus: {
    LOADING: 0,
    ENABLED: 1,
    TRASH_CAN: 2,
    IN_FLOW: 3,
    OBSOLETE: 4,
    IN_CHECKOUT: 5,
    WAITING_FILE: 6,
    WAITING_SIGNERS: 8,
    IN_FLOW_TRASH_CAN: 9,
  },
};
